import React from 'react';
import {Segment, List } from 'semantic-ui-react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization, interpolateString} from "../utils/localization";
import moment from "moment";
import {uiFlowBenAdmin, isAnsel, isSymetra, isAIG} from "../utils/common";
import {CustomGrid} from "./custom-common";

const mapStateToProps = ({initialData, user}, ownProps) => ({
    ...ownProps,
    user,
    initialData,
    contractInfo: initialData.contractInfo,
    isBenAdmin: initialData.uiFlow === uiFlowBenAdmin,
    lang: user.lang,
});


const PlanWarningsBanner = ({ initialData, contractInfo, lang, isBenAdmin, user }) => {
    const localization = getLocalization(lang);
    const strings = localization.plan;
    const {important, thisProductIsOnlyAvailable, basedOnBenefit} = strings;
    const {ageReduction, ageReductionAge, ageReductionPercentage} = initialData.policy;

    const stateWarningMessageMap = isAnsel() || isAIG() ? {'CA': thisProductIsOnlyAvailable, 'PA': thisProductIsOnlyAvailable} : isSymetra() ? {'PA': thisProductIsOnlyAvailable} : {};
    const stateWarningMessage = stateWarningMessageMap[contractInfo?.issueState] || null;
    const hasToDisplayEmployerStateMessage = !!stateWarningMessage;
    let hasToDisplayAgeReductionMessage = false;

    if(ageReduction){
        let age = initialData.ageAtPolicyEffectiveDate;
        if (isBenAdmin) {
            age = moment(initialData.policy.polEDate, 'YYYY-MM-DD').diff(moment(user.birthdate, 'MM/DD/YYYY'), 'years');
        }
        if (age >= ageReductionAge) {
            hasToDisplayAgeReductionMessage = true;
        }
    }

    if (!hasToDisplayAgeReductionMessage && !hasToDisplayEmployerStateMessage) {
        return null;
    }

    const getAgeReductionText = () => interpolateString(basedOnBenefit, [ageReductionPercentage]);

    const renderContentOptions = {
        renderMultipleMessages: (messages) => (
            <>
                <p className={'noMargin'}><b>{important}</b></p>
                <List bulleted className={'planWarningsBannerList'}>
                    {messages.map((message, index) => <List.Item key={index}>{message}</List.Item>)}
                </List>
            </>
        ),
        renderSingleMessage: (message) => (
            <span><b>{important}: </b>{message}</span>
        ),
        default: () => null
    };

    const renderContent = () => {
        if (hasToDisplayEmployerStateMessage && hasToDisplayAgeReductionMessage) {
            return renderContentOptions.renderMultipleMessages([getAgeReductionText(), stateWarningMessage]);
        }
        if (hasToDisplayEmployerStateMessage || hasToDisplayAgeReductionMessage) {
            const message = stateWarningMessage || getAgeReductionText();
            return renderContentOptions.renderSingleMessage(message);
        }
        return renderContentOptions.default()
    }

    return (
        <CustomGrid.Row columns={1}>
            <CustomGrid.Column textAlign={'left'} width={12}>
                <Segment basic className={"planWarningsBannerContainer bkgLinen small"}>
                    {renderContent()}
                </Segment>
            </CustomGrid.Column>
        </CustomGrid.Row>
    )
}

export default withRouter(connect(mapStateToProps)(PlanWarningsBanner));
